import { useEffect, useState } from "react";
import api from "@/lib/api";
import { blip } from "@/lib/sound";
import { setSeo, ogImageUrl } from "@/lib/seo";
import { ESShell, ESBlocks } from "@/components/public/ESBlockRenderer";
import EmotionalSignalLanding from "@/pages/public/EmotionalSignalLanding";

export default function ESHome() {
  const [page, setPage] = useState(undefined);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/public/home").then((r) => setPage(r.data)).catch(() => setPage(null));
    api.get("/public/settings").then((r) => {
      setSettings(r.data);
      const s = r.data;
      if (s.gtm_id && /^GTM-[A-Z0-9]+$/i.test(s.gtm_id) && !document.getElementById("gtm-script")) {
        const el = document.createElement("script"); el.id = "gtm-script";
        el.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${s.gtm_id}');`;
        document.head.appendChild(el);
      }
      if (s.meta_pixel_id && /^\d{5,}$/.test(s.meta_pixel_id) && !document.getElementById("fb-pixel")) {
        const el = document.createElement("script"); el.id = "fb-pixel";
        el.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${s.meta_pixel_id}');fbq('track','PageView');`;
        document.head.appendChild(el);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const title = page?.seo?.meta_title || settings?.site_title || "EmotionalSignal — Surreal Art for Unspoken Feelings";
    const description = page?.seo?.meta_description || settings?.site_description || "Surreal, hand-drawn art for beautifully complicated minds. Shop eyes, hearts, tears and nazar artifacts on Etsy.";
    setSeo({ title, description, image: ogImageUrl() });
  }, [page, settings]);

  if (page === undefined) {
    return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#21E6D3]/40 border-t-[#21E6D3] rounded-full animate-spin" /></div>;
  }
  // Fallback to the original static landing if no published home page exists yet,
  // or if the home has no surreal (es_) blocks to render.
  const hasES = (page?.blocks || []).some((b) => b.type?.startsWith("es_"));
  if (!page || !hasES) return <EmotionalSignalLanding />;

  const hover = (freq) => blip(freq);
  return (
    <ESShell blocks={page.blocks} settings={settings}>
      <ESBlocks blocks={page.blocks} onHover={hover} settings={settings} />
    </ESShell>
  );
}
